import { Children, cloneElement, useEffect, useMemo, useState } from "react";
import { node, string } from "prop-types";
import { Collapse } from "@material-ui/core";
import { SettingsButton } from "./SettingsButton";
import { ExpandMore } from "@material-ui/icons";
import classNames from "classnames";
import classnames from "classnames";

export const SettingsButtonGroup = ({
  titleKey,
  children,
}) => {
  
  const [opened, setOpen] = useState(false);
  
  const activePath = useMemo(() => (
    Children
      .toArray(children)
      .find(child => (
        child.props.path && location.pathname === child.props.path
      ))?.props.path
  ), [children, location.pathname]);
  
  const path = useMemo(() => (
    activePath || Children.toArray(children)[0].props.path
  ), [children, activePath]);
  
  useEffect(() => {
    if(activePath)
      setOpen(true);
  }, [activePath]);
  
  const handleClick = (e) => {
    e.stopPropagation();
    // e.preventDefault();
    if(!activePath)
      setOpen(true);
    else setOpen(!opened);
  }
  
  return <>
    <SettingsButton
      icon={<ExpandMore
        className={classNames(
          "expand transition ",
          opened && "-rotate-180"
        )}
      />}
      onClick={ handleClick }
      path={path}
      forceActive={!!activePath}
      titleKey={titleKey}
    />
    <Collapse
      in={opened}
      timeout="auto"
      mountOnEnter
      unmountOnExit
    >
      {
        Children.map(children, (child) => (
          cloneElement(child, {
            ...child.props,
            className: classnames(child.props.className, "ml-4")
          })
        ))
      }
    </Collapse>
  </>
}

SettingsButtonGroup.propTypes = {
  titleKey: string.isRequired,
  icon: node.isRequired,
  children: node.isRequired,
}